import Vue from 'vue';
import notify from './notification/notifications';
import moment from 'moment';

const dataFormatada = (datestr) => moment(datestr).format('DD/MM/YYYY');

const mixins = {
  data: () => {
    return {notify, moment, dataFormatada}
  }
};

Vue.mixin(mixins);



// WEBPACK FOOTER //
// ./src/components/shared/mixins.js